import { useTranslation } from "react-i18next";
import { LANGUAGE_STORAGE_KEY, normalizeLanguageCode, toUiLanguageCode } from "../../i18n";

const LanguageToggle = ({ className = "" }) => {
    const { i18n } = useTranslation();
    const lang = toUiLanguageCode(i18n.language || i18n.resolvedLanguage);

    const handleLanguageChange = (nextLanguage) => {
        const normalizedLanguage = normalizeLanguageCode(nextLanguage);
        localStorage.setItem(LANGUAGE_STORAGE_KEY, normalizedLanguage);
        i18n.changeLanguage(normalizedLanguage);
    };

    return (
        <div className={`flex items-center gap-3 rounded-full bg-white px-4 py-2 text-xs shadow-md ${className}`}>
            <button
                type="button"
                onClick={() => handleLanguageChange("EN")}
                className={`transition focus:outline-none ${lang === "EN" ? "text-primary underline underline-offset-2" : "text-slate-400 hover:text-slate-600"}`}
            >
                EN
            </button>
            <button
                type="button"
                onClick={() => handleLanguageChange("GR")}
                className={`transition focus:outline-none ${lang === "GR" ? "text-primary underline underline-offset-2" : "text-slate-400 hover:text-slate-600"}`}
            >
                GR
            </button>
        </div>
    );
};

export default LanguageToggle;
